import { Theme } from '@radix-ui/themes'
import clsx from 'clsx'
import React from 'react'
import ReactDOM from 'react-dom'
import { useSelector } from 'hooks/use-redux'
import { getLabelSelectedItems } from '@disco/utils/string-utils'
import ButtonContainer from 'components/ui/button-container'
import styles from './index.module.css'
import { SelectableItem } from '@disco/types/types/selection'

let appNode

if (typeof document !== 'undefined') {
  appNode = document.getElementById('app') || document.getElementById('__next')
}

const ExplorerActionMenuContainer = ({
  selectedItems,
  buttons,
  children,
  label,
  className,
}: {
  selectedItems: SelectableItem[]
  buttons?: React.ReactNode[]
  children: React.ReactNode
  /** Overrides the default "Edit N items" label. */
  label?: string
  /** Extra class on the floating bar, e.g. to adjust its position. */
  className?: string
}): any => {
  const hasPlayer = useSelector(state => Boolean(state.media.trackOriginalId))
  if (!appNode) return null
  return ReactDOM.createPortal(
    // hasBackground={false}: this Theme only exists to give the fixed-position
    // pill below it dark-mode CSS variables. Left at its true-by-default
    // value, Radix paints a solid near-black background on THIS wrapper div
    // too - and since the wrapper is a normal-flow block (only its child is
    // position:fixed), that background fills real space in the document,
    // showing up as a stray black block once the page is tall enough to
    // scroll past the app's main content.
    <Theme appearance="dark" hasBackground={false}>
      <div
        className={clsx(styles.explorerActionMenuContainer, className, {
          [styles.explorerActionMenuContainerWithPlayer]: hasPlayer,
        })}
      >
        <span className={styles.explorerActionMenuContainerLabel}>
          {label ?? getLabelSelectedItems(selectedItems)}
        </span>

        <ButtonContainer>
          {buttons}

          {children}
        </ButtonContainer>
      </div>
    </Theme>,
    appNode,
  )
}

export default ExplorerActionMenuContainer
